const MCP_FLOW_KEY = 'mcpSignupFlow';

export const isMcpFlow = () => sessionStorage.getItem(MCP_FLOW_KEY) === 'true';

export const setMcpFlow = () => sessionStorage.setItem(MCP_FLOW_KEY, 'true');

export const clearMcpFlow = () => sessionStorage.removeItem(MCP_FLOW_KEY);

export const useMcpFlow = () => ({
  clearMcpFlow,
  isMcpFlow: isMcpFlow(),
  setMcpFlow,
});
